// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__23uSq","header":"MessagesList_header__IpyYf","chat":"MessagesList_chat__25o9J"};